import React from "react";
import DynamicTable from "../../widgets/dynamicTable/DynamicTable.jsx";
import HelperMetiers360 from "../../../services/HelpersMetiers360.js";
import PropTypes from 'prop-types';
import '../preparatoryOrders/PreparatoryOrderTableComponent.scss';


const LoaderAccessPingsTableComponent = ({ loaderAccessPings }) => {

    const sortType = loaderAccessPings?.length > 0
        && [
            {
                value : 'type', label : 'Action',
                test : HelperMetiers360.isArrayContainsValue(loaderAccessPings, "type"),
                method : (a, b) => HelperMetiers360.localeCompareWithNullable(a.type.label, b.type.label),
                display: (loaderAccess) => loaderAccess.type.label
            },
            {
                value : 'date', label : 'Date',
                test : HelperMetiers360.isArrayContainsValue(loaderAccessPings, "date"),
                method: (a, b) => HelperMetiers360.dateCompareWithNullableDescending(a.date, b.date),
                display: (loaderAccess) => loaderAccess?.date ? HelperMetiers360.getdisplayDateType(loaderAccess.date) : '-'
            }
        ];


    return sortType && 
        <DynamicTable 
        contentTable={loaderAccessPings}
        contentSort={sortType}
        valueInitSort="date"
        index='uniqueId'
        tableName="loaderAccessPingsTable"
            filename="loader_pings"
        />;
};

LoaderAccessPingsTableComponent.propTypes = {
    loaderAccessPings: PropTypes.array.isRequired,
};

export default LoaderAccessPingsTableComponent;